// extracted by mini-css-extract-plugin
export var container = "_53-0";
export var icon = "_53-1";
export var text = "_53-2";